export const OZON_COUNTERPARTY_NAME = 'OZON'.toLocaleLowerCase();
